// extracted by mini-css-extract-plugin
export var dropdownButton = "_3n-0";
export var fullWidthDropdownButton = "_3n-1";
export var icon = "_3n-3";
export var iconPlaceholder = "_3n-2";
export var menuItemRow = "_3n-5";
export var shortcutContainer = "_3n-4";